






















































































































































































import { Vue, Component } from 'vue-property-decorator'
import HeaderBar from '@/components/header-bar/index.vue'
import Popup from '@/components/popup/index.vue'
import { formatSeconds } from '@/utils/formator.ts'
import * as videosService from '@/services/videos'
import { checkStatusMap } from '@/constants/statusMap'

interface CurType {
  id?: number
}

@Component({ components: { HeaderBar, Popup } })
export default class Videos extends Vue {
  pageNo = 1
  pageSize = 20
  isOperate = false
  isDel = false
  isCheck = false
  curVideo: CurType = {}
  result = {}
  isSearch = false
  searchKey = ''
  $toast: any
  checkStatusMap = checkStatusMap
  timerId: any
  isloading = false
  isFetchVideosList = true

  get videos() {
    return (this.$store.state.videos && this.$store.state.videos.list) || []
  }
  get total() {
    return (
      (this.$store.state.videos.videoPage &&
        this.$store.state.videos.videoPage.totalCount) ||
      0
    )
  }
  created() {
    // if (this.videos && this.videos.length == 0) {
    this.fetchVideos()
    // }
  }

  mounted() {
    this.$nextTick(() => {
      //滚动加载列表
      document.addEventListener('scroll', this.onScroll, false)
      //发布中倒计时
      // this.countdown()
    })
  }

  destroyed() {
    document.removeEventListener('scroll', this.onScroll)
    clearInterval(this.timerId)
  }

  operate(data = {}) {
    this.curVideo = data
    this.isOperate = true
  }

  onScroll() {
    if (this.videos.length >= this.total) {
      return
    }
    const top = document.documentElement.scrollTop || document.body.scrollTop
    const routerView = document.querySelector('.router-view')

    const vh =
      document.compatMode == 'CSS1Compat'
        ? document.documentElement.clientHeight
        : (routerView as HTMLElement).offsetHeight // 浏览器视口的高度
    const height = Math.max(
      (routerView as HTMLElement).offsetHeight,
      document.documentElement.scrollHeight
    ) // 文档的总高度
    if (top + vh >= height - 50 && this.isFetchVideosList === true) {
      // 滚动到底部
      this.pageNo++
      this.fetchVideos().then(() => {
        this.isFetchVideosList = true
      })
    }
  }

  fetchVideos() {
    if (this.pageNo === 1) {
      this.isFetchVideosList = true
    } else {
      this.isFetchVideosList = false
    }
    return this.$store.dispatch('videos/fetchVideos', {
      uuid: this.$store.state.userInfo.uuid,
      pageNum: this.pageNo,
      pageSize: 10,
      title: this.searchKey,
      checkState: 99,
    })
  }

  formatSeconds(val = 0) {
    return formatSeconds(val)
  }
  //发布视频
  async pubVideo() {
    if (this.isloading) {
      return
    }
    if (this.curVideo.id) {
      this.isOperate = false
      this.updateList(1)
      this.$toast('操作上线中，请等待')
      this.isloading = true
      const data = await videosService.pubVideo(this.curVideo.id)
      this.isloading = false
      this.$toast(data.msg)
    }
  }
  //查看原因
  async checkResult() {
    if (this.isloading) {
      return
    }
    if (this.curVideo.id) {
      this.isloading = true
      const data = await videosService.getVideoLogs(this.curVideo.id)
      this.isloading = false
      this.isOperate = false
      this.isCheck = true
      if (data.code == 200 && data.data) {
        this.result = data.data[0]
      }
    }
  }
  //删除视频
  async delVideo() {
    if (this.isloading) {
      return
    }
    if (this.curVideo.id) {
      this.isloading = true
      const data = await videosService.delVideo(this.curVideo.id.toString())
      this.isloading = false
      this.$toast(data.msg)

      if (data.code != 200) {
        return
      }
      this.isOperate = false
      this.isDel = false
      const newArr: Array<object> = []
      for (let i = 0; i < this.videos.length; i++) {
        if (this.curVideo.id == this.videos[i].id) {
          continue
        }
        newArr.push(this.videos[i])
      }
      this.$store.commit('videos/setVideos', newArr)
    }
  }
  //取消发布视频
  async delPub() {
    if (this.isloading) {
      return
    }
    if (this.curVideo.id) {
      this.isOperate = false
      this.updateList(-5) //下线中
      this.$toast('操作下线中，请等待')
      this.isloading = true
      await videosService.dePubVideo(this.curVideo.id.toString())
      this.isloading = false
    }
  }
  //取消定时发布视频
  async delTimerPub() {
    if (this.isloading) {
      return
    }
    if (this.curVideo.id) {
      this.isOperate = false
      this.updateList(-5) //下线中
      this.$toast('操作下线中，请等待')
      this.isloading = true
      await videosService.deTimerPubVideo(this.curVideo.id)
      this.isloading = false
    }
  }
  //操作后改变列表
  updateList(type: number) {
    const newArr: Array<object> = []
    const list = this.videos
    for (let i = 0; i < list.length; i++) {
      if (list[i] && this.curVideo.id == list[i].id) {
        list[i].checkState = type
      }
      newArr.push(list[i])
    }

    this.$store.commit('videos/setVideos', newArr)
  }
  //取消搜索
  cancelSearch() {
    this.isSearch = false
    this.searchKey = ''
    this.searchList()
  }
  //搜索
  searchList() {
    this.pageNo = 1
    this.fetchVideos()
  }
  //倒计时
  countdown() {
    clearInterval(this.timerId)
    this.timerId = setInterval(() => {
      this.firstTimer()
    }, 1000)
  }
  firstTimer() {
    const now = new Date().getTime()
    const list = this.videos.slice()
    for (let i = 0; i < list.length; i++) {
      if (list[i].checkState == 4 && list[i].timerState > 0) {
        let datestr = list[i].timerTime
        datestr = datestr.substring(0, 19)
        datestr = datestr.replace(/-/g, '/')
        const publishDate = new Date(datestr).getTime()
        const remainTime = Math.max(~~((publishDate - now) / 1000), 0)
        if (remainTime == 0) {
          list[i].checkState = 1
        }
        this.showtime(this.videos[i], remainTime)
      }
    }
  }
  //更新列表发布中时间显示
  showtime(item: any, time: number) {
    const newArr: Array<object> = []
    for (let i = 0; i < this.videos.length; i++) {
      if (item.id == this.videos[i].id) {
        this.videos[i].timerCount = time ? formatSeconds(time) : ''
      }
      newArr.push(this.videos[i])
    }
    this.$store.commit('videos/setVideos', newArr)
  }

  toSchema(item: any) {
    if (item.checkState == 6) {
      window.location.href = `imgotv://player?videoId=${item.vrsId}`
    }
  }
}
